import { useEditorState } from '@tiptap/react';
import type { Editor } from '@tiptap/core';

const MARKS = ['bold', 'italic', 'underline', 'strike', 'uppercase'];

// Toggling a mark does not change the selection, so the panel needs editor state.
export const useActiveMarks = (editor: Editor | null): Record<string, boolean> =>
	useEditorState({
		editor,
		selector: ({ editor: current }) => {
			if (!current) {
				return {};
			}
			return Object.fromEntries(MARKS.map((mark) => [mark, current.isActive(mark)]));
		},
	}) ?? {};
